// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3qC9H","alertIcon":"ConfirmModal_alertIcon__A2txg"};